import React from "react";
import ReactDOM from "react-dom";
import "babel-polyfill";

import App from "./app.jsx";

ReactDOM.render(<App />, document.getElementById("app-container"));
